import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Shingles from "@/pages/Shingles";
import Admin from "@/pages/Admin";
import QR from "@/pages/QR";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App min-h-screen bg-slate-950 text-slate-100 font-body">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shingles" element={<Shingles />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/qr" element={<QR />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors closeButton />
    </div>
  );
}

export default App;
